import { render, staticRenderFns } from "./CopyTemplateSteps.vue?vue&type=template&id=f9456134&scoped=true"
import script from "./CopyTemplateSteps.vue?vue&type=script&lang=js"
export * from "./CopyTemplateSteps.vue?vue&type=script&lang=js"
import style0 from "./CopyTemplateSteps.vue?vue&type=style&index=0&id=f9456134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9456134",
  null
  
)

export default component.exports